import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIcons1001tracklistsComponent } from './simple-icons-1001tracklists.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIcons1001tracklistsComponent ],
    exports:      [ SimpleIcons1001tracklistsComponent ],
    bootstrap:    []
})
export class SimpleIcons1001tracklistsModule {}
